import { useQuery } from "@tanstack/react-query"
import { getActivePendingContactChange } from "@/api"

export const useActivePendingContactChange = () => {
  return useQuery({
    queryKey: ["activePendingContactChange"],
    queryFn: getActivePendingContactChange,
  })
}
